/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { compose } from 'redux';
import find from 'lodash/find';
import TranslationsScope from '@client/components/shared/translation/TranslationsScope';
import {
    BottomBubble,
    FlashMessage,
    Recommendations,
    Spinner
} from '@client/components/shared/Shared';
import {
    buildUrlForRouteLoadingError
} from '@client/components/shared/Helpers';
import SecondarySubscriptionContainerSlick from '@client/components/shared/SecondarySubscription/SecondarySubscription';
import {
    TRACK_RECO_CAMPAIGN_OVERVIEW,
    RECO_ITEM_WIDTH
} from '@client/config/constants';
import {
    isXsScreen
} from '@client/helpers/screens';
import {
    SectionTitle
} from '@client/components/shared/Shared';
import Banner from './banner/banner-legacy';
import Grid from './campaigns/Grid';
import MobileCampaigns from './campaigns/mobileCampaigns/MobileCampaigns';
import UpcomingSection from './campaigns/UpcomingSection';
import HiddenCampaign from './HiddenCampaign';
import styles from './MyLoungeWrapper.scss';

export class MyLoungeWrapper extends Component {
    static propTypes = {
        routeLoading: PropTypes.bool.isRequired,
        mylounge: PropTypes.object.isRequired,
        clientDevice: PropTypes.object.isRequired,
        updateSelectedFilter: PropTypes.func.isRequired,
        updateCategorySlideIndex: PropTypes.func.isRequired,
        toggleWelcomeBox: PropTypes.func.isRequired,
        closeWelcomeBox: PropTypes.func.isRequired,
        params: PropTypes.object,
        flashMessage: PropTypes.object.isRequired,
        location: PropTypes.object,
        routeLoadingErrors: PropTypes.any,
    };

    render() {
        const {
            mylounge,
            location,
            params,
            routeLoading,
            flashMessage
        } = this.props;

        if (!mylounge) {
            return null;
        }

        const {
            tabs,
            selectedFilter,
            hiddenCampaign,
        } = mylounge;

        const { width, height } = this.props.clientDevice || {};
        const activeCategory = find(tabs, { tag: selectedFilter || 'all' });

        if (routeLoading && !activeCategory) {
            return (
                <section styleName="wrapper-loader">
                    <div styleName="spinner">
                        <Spinner black={true} />
                    </div>
                </section>
            );
        }
        const xsScreen = isXsScreen(width);

        // to avoid events firing twice, the second <Grid /> component receives a no-op function for resize handler
        return (
            <TranslationsScope path="myLounge">
                <div styleName="outer-wrapper">
                    {tabs.length &&
                        <Banner
                            tabs={tabs}
                            selectedFilter={selectedFilter}
                        />
                    }
                    <SecondarySubscriptionContainerSlick />
                    <section styleName="wrapper">
                        {flashMessage ? flashMessage.flashMessages.map(message => (
                            <FlashMessage
                                type={message.type}
                                text={message.text}
                            />
                        )) : null}
                        {xsScreen && hiddenCampaign && (
                            <div styleName="hidden-campaign">
                                <HiddenCampaign campaign={hiddenCampaign} />
                            </div>
                        )}
                        {xsScreen ?
                            <MobileCampaigns
                                id="open"
                                width={width}
                                height={height}
                                params={params}
                                myloungeData={mylounge.open}
                                location={location}
                            />
                            :
                            <Grid
                                id="open"
                                width={width}
                                params={params}
                                campaigns={mylounge.open}
                                hiddenCampaign={hiddenCampaign}
                                location={location}
                            />
                        }
                        <SectionTitle message="recommendations.sectionTitle" />
                        <Recommendations
                            recommendations={mylounge.recommendation}
                            width={width}
                            itemWidth={RECO_ITEM_WIDTH}
                            source={TRACK_RECO_CAMPAIGN_OVERVIEW}
                        />
                        <UpcomingSection location={location} params={params} hasTitle />
                    </section>
                    <BottomBubble />
                </div>
            </TranslationsScope>
        );
    }

    componentDidMount() {
        if (this.props.routeLoadingErrors) {
            this.context.router.push(
                buildUrlForRouteLoadingError(this.props.routeLoadingErrors, this.context.router.getCurrentLocation())
            );
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.routeLoadingErrors) {
            // TODO 28.01.19 Think of a better solution, investigate buildUrlForRouteLoadingError
            // if (!nextProps.routeLoadingErrors.code && !nextProps.routeLoadingErrors.campaignIdentifier) {
            //     return false;
            // }

            this.context.router.push(
                buildUrlForRouteLoadingError(nextProps.routeLoadingErrors, this.context.router.getCurrentLocation())
            );

            return false;
        }

        return true;
    }
}

MyLoungeWrapper.contextTypes = {
    router: PropTypes.object
};

export default compose(
    CSSModules(styles, { allowMultiple: true })
)(MyLoungeWrapper);
